import {
  Component,
  OnInit,
  Input,
  Renderer2,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-team-card-point-edit",
  templateUrl: "./team-card-point-edit.component.html",
  styleUrls: ["./team-card-point-edit.component.scss"],
})
export class TeamCardPointEditComponent implements OnInit {
  @ViewChild("input") input: ElementRef;
  @Input()
  value;
  @Input()
  indexOfScore;
  isBeingEdited;
  @Input()
  inputType = "number";
  @Output()
  valueEmitted = new EventEmitter();
  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {}

  onEdit() {
    this.isBeingEdited = !this.isBeingEdited;
    if (this.isBeingEdited) {
      setTimeout(() => {
        const element = this.renderer.selectRootElement(
          `#input-${this.indexOfScore}`
        );
        element.focus();
      }, 50);
    }
  }
  finalizeEvent(event) {
    event.preventDefault();
    const {
      target: { value: roundValue },
    } = event;
    this.isBeingEdited = false;
    if (roundValue) {
      this.emitValue(roundValue);
    }
  }

  emitValue(score) {
    this.valueEmitted.emit({ score, index: this.indexOfScore });
  }
  onKey(event) {
    this.input.nativeElement.blur();
  }
  onBlur(event) {
    this.finalizeEvent(event);
  }
}
